import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { registerCart } from '../../../../services/ebon/actions';

import useCartController from '../../../../services/ebon/hooks/useCartController';

import { formatAmountCurrency } from '../../../../utils';
import { convertDate } from '../../../../utils/dateUtils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Hidden from '../../../Hidden/Hidden';
import BasketRowItem from '../../merchantcard/BasketRowItem';
import ButtonComponent from '../../../button/ButtonComponent';

import './PaymentRequestEbonSelectorComponent.scss';

const EbonSelectorComponent = ({
    ebons,
    i18n,
    partner,
    registerCart,
    validatedCashbackAmount,
    ebonPaymentConfig
}) => {
    const [selectedEbon, setSelectedEbon] = useState({});
    const [quantity, setQuantity] = useState(0);
    const { availabilityResponses = {} } = ebons;
    const {
        cart,
        addItemCart,
        handleItemChange,
        getCartTotal,
        getCartQuantity
    } = useCartController();

    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;

    const handleAddItem = (facialValue, quantityQuery, quantityAvailable) => {
        addItemCart({
            facialValue: facialValue || selectedEbon.facialValue,
            quantityQuery: quantityQuery || quantity,
            quantityAvailable: quantityAvailable,
            partnerId: ebons.ebonDiscount.partnerId
        });
    };

    const handleQuantity = e => {
        if (e === '-') {
            if (quantity > 1) {
                setQuantity(quantity - 1);
            }
        } else if (e === '+') {
            if (
                quantity < selectedEbon.quantityAvailable &&
                (!basketLimit || quantity < basketLimit)
            ) {
                setQuantity(quantity + 1);
            }
        }
    };

    useEffect(() => {
        const initQuantity =
            selectedEbon && selectedEbon.facialValue
                ? selectedEbon.facialValue.quantityQuery || 1
                : 1;
        setQuantity(initQuantity);
    }, [selectedEbon]);

    useEffect(() => {
        setSelectedEbon({});
    }, [partner]);

    const cartValidation = () => {
        registerCart(cart);
    };

    useEffect(() => {}, [selectedEbon]);

    const handleSelectEbon = e => {
        const ebonValue = e.target.value;
        const ebonSelected = availabilityResponses.find(
            ebon => ebon.facialValue.toString() === ebonValue
        );
        setSelectedEbon(ebonSelected ? ebonSelected : {});
    };

    const isEbonAvalaible = ebon => {
        if (ebon.quantityAvailable > 0 && ebon.expirationDate > 0) {
            return true;
        }
        return false;
    };

    const isBasketLimitReached = () => {
        const cartTotalQuantity = getCartQuantity(cart);
        return basketLimit && cartTotalQuantity >= basketLimit;
    };

    const compareCartAmountToValidatedCashback = () => {
        if (validatedCashbackAmount >= getCartTotal()) {
            return false;
        }
        return true;
    };

    return (
        <div id="p-ebon-selector-payment-request" className="container">
            <React.Fragment>
                <div className="left-container">
                    <p className="valueTips">
                        <span>{i18n.VALUE}</span>
                        {i18n.VALUE_TIPS}
                    </p>
                    <div className="ebon-selector-container">
                        <Hidden breakpoint="mdDown">
                            <div className="ebon-container">
                                {availabilityResponses &&
                                    availabilityResponses
                                        .sort((a, b) => a.facialValue - b.facialValue)
                                        .map(ebon => (
                                            <button
                                                key={ebon.facialValue}
                                                onClick={() => {
                                                    if (
                                                        selectedEbon.facialValue ===
                                                        ebon.facialValue
                                                    ) {
                                                        setSelectedEbon({});
                                                    } else {
                                                        setSelectedEbon(ebon);
                                                    }
                                                }}
                                                className={`button-ebon ${
                                                    selectedEbon.facialValue === ebon.facialValue
                                                        ? 'selected'
                                                        : ''
                                                }`}
                                                disabled={!isEbonAvalaible(ebon)}>
                                                <p className="value">
                                                    {formatAmountCurrency(ebon.facialValue)}
                                                </p>
                                                {!isEbonAvalaible(ebon) && (
                                                    <p className="soldOut">{i18n.SOLD_OUT}</p>
                                                )}
                                            </button>
                                        ))}
                            </div>
                        </Hidden>
                        <Hidden breakpoint="mdUp">
                            <select
                                name="ebons"
                                className="ebon-select"
                                value={selectedEbon.facialValue}
                                onChange={handleSelectEbon}>
                                <option value="">{i18n.MOBILE_SELECT}</option>
                                {availabilityResponses.map((ebon, i) => (
                                    <option
                                        key={ebon.facialValue}
                                        value={ebon.facialValue}
                                        disabled={!isEbonAvalaible(ebon)}>
                                        {`${formatAmountCurrency(ebon.facialValue)} ${
                                            !isEbonAvalaible(ebon) ? '- ' + i18n.SOLD_OUT : ''
                                        }`}
                                    </option>
                                ))}
                            </select>
                        </Hidden>
                        <div>
                            <p className="availability">
                                {convertHtmlToReactDomWithParams(
                                    i18n.EBON_AVAILABILITY,
                                    convertDate(selectedEbon.expirationDate)
                                )}
                            </p>
                            <div className="quantity-selector">
                                <p>{i18n.QUANTITY}</p>
                                <div className="quantity-button">
                                    <button
                                        onClick={() => handleQuantity('-')}
                                        disabled={quantity <= 1}>
                                        -
                                    </button>
                                    <div>{quantity}</div>
                                    <button
                                        onClick={() => handleQuantity('+')}
                                        disabled={
                                            quantity >= selectedEbon.quantityAvailable ||
                                            (basketLimit && quantity === basketLimit)
                                        }>
                                        +
                                    </button>
                                </div>
                            </div>

                            {(selectedEbon.quantityAvailable === 1 || basketLimit) && (
                                <div className="error-area">
                                    {selectedEbon.quantityAvailable === 1 && (
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.LIMITED_REMAINING_EBON,
                                                selectedEbon.quantityAvailable,
                                                selectedEbon.quantityAvailable > 1 ? 's' : ''
                                            )}
                                        </p>
                                    )}
                                    {basketLimit && (
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18n.CAPPING_MESSAGE,
                                                basketLimit,
                                                basketLimit > 1 ? 's' : ''
                                            )}
                                        </p>
                                    )}
                                </div>
                            )}

                            <div className="resum-area">
                                <p>
                                    {selectedEbon.facialValue &&
                                        convertHtmlToReactDomWithParams(
                                            i18n.RESUM_EBON,
                                            quantity,
                                            quantity > 1 ? 's' : '',
                                            formatAmountCurrency(selectedEbon.facialValue)
                                        )}
                                </p>
                            </div>
                            <div className="button-add">
                                <ButtonComponent
                                    disabled={isEmpty(selectedEbon) || isBasketLimitReached()}
                                    onClick={() => {
                                        handleAddItem(
                                            selectedEbon.facialValue,
                                            quantity,
                                            selectedEbon.quantityAvailable
                                        );
                                        setSelectedEbon({});
                                    }}
                                    cssClass={`${!selectedEbon.quantityAvailable &&
                                        'none-selected'}`}
                                    color="main"
                                    text={i18n.ADD_BASKET}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right-container">
                    <p>
                        <span>{i18n.BASKET}</span>
                    </p>
                    <div className="cart-container">
                        {cart.length < 1 ? (
                            <p>{i18n.EMPTY_BASKET}</p>
                        ) : (
                            <React.Fragment>
                                {cart
                                    .sort((a, b) => a.facialValue - b.facialValue)
                                    .map((e, i) => {
                                        const amount = (e.facialValue || 0) * e.quantityQuery || 0;
                                        return (
                                            <BasketRowItem
                                                text={`${i18n.BON_ACHAT} - ${partner.name}`}
                                                ebon={e}
                                                amount={amount}
                                                key={i}
                                                handleItemChange={handleItemChange}
                                                isBasketLimitReached={isBasketLimitReached()}
                                            />
                                        );
                                    })}
                            </React.Fragment>
                        )}
                    </div>

                    <div>
                        <div className="resum-container">
                            <div className="row-text green">
                                <p>{i18n.TOTAL_TTC}</p>
                                <span className="amount">
                                    {formatAmountCurrency(getCartTotal(cart))}
                                </span>
                            </div>
                        </div>
                        <div className="button-add">
                            <ButtonComponent
                                disabled={
                                    cart.length <= 0 || compareCartAmountToValidatedCashback()
                                }
                                onClick={() => cartValidation()}
                                color="main"
                                text={i18n.VALIDATE_BASKET}
                            />
                            {compareCartAmountToValidatedCashback() && (
                                <p className="error">
                                    {i18n.AMOUNT_SUPERIOR_TO_VALIDATED_CASHBACK}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </div>
    );
};

EbonSelectorComponent.propTypes = {
    ebons: PropTypes.object.isRequired,
    partner: PropTypes.object.isRequired,
    validatedCashbackAmount: PropTypes.number.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT.EBON_SELECTOR,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    registerCart
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorComponent));



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestEbonSelectorComponent.js